@let tier = content().tier;
@let priority = content().priority;
@let skyPrioritySuffix = get360AndSkyPriority(tier, priority);
<div [class]="getAccountStatus()">
  <div class="skymiles-medallion-banner__align">
    <div
      [class]="
        'skymiles-medallion-banner__status__container' +
        (priority.label !== '' && priority.url !== ''
          ? ' skymiles-medallion-banner__status__container__sky-priority'
          : ' skymiles-medallion-banner__status__container__normal') +
        (tier.title
          ? ''
          : ' skymiles-medallion-banner__status__container--tier-title')
      "
    >
      @if (priority.label !== '' && priority.url !== '') {
        <button
          [attr.aria-label]="ariaLabel().skyPriority"
          role="button"
          (click)="redirect.emit(priority)"
          [class]="
            'button button-primary skymiles-medallion-banner__status__container__sky-priority__label' +
            skyPrioritySuffix
          "
        >
          {{ priority.label }}
        </button>
      }
      <!-- add condition here to check this view is not for omnipro -->
      @if (tier.title) {
        <div
          [class]="
            ' skymiles-medallion-banner__status__container__tier__wrapper' +
            skyPrioritySuffix
          "
        >
          <span
            [class]="
              ' skymiles-medallion-banner__status__container__tier__wrapper__title' +
              skyPrioritySuffix
            "
          ></span>
          {{ tier.title }}
          <span
            class="skymiles-medallion-banner__status__container__tier__wrapper__subtitle"
          >
            {{ tier.subtitle }}
          </span>
        </div>
      }

      <span
        [class]="
          'skymiles-medallion-banner__status__container__tier__enroll-date skymiles-medallion-banner__enroll-date' +
          ' skymiles-medallion-banner__status__container__tier__enroll-date' +
          skyPrioritySuffix +
          (tier.title
            ? ''
            : ' skymiles-medallion-banner__status__container__tier__enroll-date--tier-title')
        "
      >
        {{ content().enrollDate }}
      </span>
    </div>
  </div>
</div>
